// work this
import {
    api_admin_companies_get,
    // api_admin_companies_get,
    api_admin_companies_search_list,
    api_admin_helmet_extensions_list,
    api_admin_helmets_del,
    api_admin_helmets_patch,
    api_admin_helmets_post,
    Company,
    Helmet,
    HelmetExtension,
} from 'abi'
import { addAlert, HoverInp, LoadingDots, setPopup } from 'components'
import {
    ArrowDownIcon,
    CalendarIcon,
    CheckboxFill,
    CheckboxUnFill,
    CheckFillIcon,
    CloseIcon,
    CorpsIcon,
    DeleteIcon,
    EditIcon,
    PrintIcon,
    SelectAllIcon,
    SettingFillIcon,
    WarningIcon,
} from 'icons'
import readXlsxFile, { Row } from 'read-excel-file'

import {
    Component,
    createEffect,
    createMemo,
    createSignal,
    For,
    on,
    onCleanup,
    onMount,
    Setter,
    Show,
} from 'solid-js'
import { createStore, produce } from 'solid-js/store'
import { debounce, deepcopy, objentries } from 'utils/tools'
import { INSURANCE_STATE } from '.'

import { AddBtn } from 'components/addBtn'
import { LOCAL_ECONOMIC_NUMBER, LOCAL_INSURER_PHONE } from 'store/labels'
import {
    DEFAULT_ECONOMIC_NUMBER,
    DEFAULT_PHONE,
    set_def_economic_number,
    setDefaultPhone,
} from '..'
import SelectedHelmets from './select'
import './style/addins.scss'

export const EXCEL_MIMES = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx, .xlsm
    'application/vnd.ms-excel', // .xls
]
export const EXCEL_EXTENSIONS = ['.xls', '.xlsx', '.xlsm'] // اضافه کن '.csv' اگر می‌خواهی csv هم پذیرفته بشه
export const ACCEPT_STRING =
    EXCEL_EXTENSIONS.join(',') + ',' + EXCEL_MIMES.join(',')

export const HELMET_DEF: Helmet = {
    id: 0,
    company: null,
    cargo: null,
    created_at: 0,
    insurer: '',
    v_color: '',
    chassis: '',
    engine: '',
    plate_serial: '',
    plate_number: '',
    vin: '',
    manufacture_year: 0,
    total_insurance_amount: 0,
    v_name: '',
    v_group: '',
    v_system: '',
    v_usage: '',
    insurance_number: 0,
    past_insurer: '',
    reagent: '',
    start_date: '',
    expiration_date: '',
    added_tax: 0,
    added_toll: 0,
    insurance_code: 0,
    issue_date: '',
    issuer: '',
    past_expiration_date: '',

    airrm_cover_life: 0,
    airrm_cover_financial: 0,
    airrm_cover_passenger: 0,
    issue_time: 0,
    unique_code: '',
    issuer_code: 0,
    third_party_insurance_amount: 0,
    passenger_insurance_amount: 0,
    life_surplus_insurance_amount: 0,
    financial_surplus_insurance_amount: 0,
    fund_fine: 0,
    print_count: 0,

    insurer_code: '',
    issue_year: 0,
    economic_number: '',
    provider: 'tejaratno',
    plate_city: '',
    insurer_phone: '',
    passenger_count: 2,
}

type ImportsT =
    | 'id'
    | 'company'
    | 'cargo'
    | 'created_at'
    | 'print_count'
    | 'insurer_phone'
    | 'passenger_count'
    | 'provider'
    | 'issue_year'
    | 'insurer_code'

const MANUALS = [
    'provider',
    'issue_year',
    'insurer_code',
    'insurer_phone',
    'passenger_count',
] as const

type ManualKey = (typeof MANUALS)[number]

export const MANUALS_LABELS: Record<ManualKey, string> = {
    provider: 'ارائه‌دهنده',
    issue_year: 'سال صدور',
    insurer_code: 'کد بیمه‌گذار',
    insurer_phone: 'شماره تلفن بیمه‌گذار',
    passenger_count: 'تعداد مسافران',
}

export type HelmetImport = Omit<Helmet, ImportsT>

export const HEL_COL_MAP: {
    [k in keyof HelmetImport]: { cx: number; cn: string[] }
} = {
    economic_number: { cx: 10, cn: ['شماره اقتصادی کسب و کار'] },
    issuer_code: { cx: 83, cn: ['کد نمایندگی تحویل', 'کاربر ثبت'] },
    unique_code: { cx: 181, cn: ['کد یکتای پیشنهاد'] },
    insurance_number: { cx: 4, cn: ['شماره بیمه نامه'] },
    insurance_code: { cx: 1, cn: ['کد رایانه بیمه نامه'] },
    insurer: { cx: 7, cn: ['بیمه گذار'] },
    v_color: { cx: 82, cn: ['رنگ خودرو', 'ColorText'] },
    chassis: { cx: 28, cn: ['شماره شاسی'] },
    engine: { cx: 27, cn: ['شماره موتور'] },
    plate_serial: { cx: 21, cn: ['سریال پلاک'] },
    plate_number: { cx: 19, cn: ['شماره پلاک'] },
    plate_city: { cx: 20, cn: ['شهر پلاک'] },
    vin: { cx: 29, cn: ['VIN'] },
    v_system: { cx: 106, cn: ['نوع وسیله نقلیه', 'سیستم خودرو'] },
    v_group: { cx: 105, cn: ['نام گروه خودرو'] },
    v_name: { cx: 22, cn: ['سیستم وسیله نقلیه', 'نوع خودرو'] },
    v_usage: { cx: 25, cn: ['مورد استفاده وسیله نقلیه', 'مورد استفاده خودرو'] },
    manufacture_year: { cx: 26, cn: ['سال ساخت وسیله نقلیه', 'سال ساخت خودرو'] },
    total_insurance_amount: { cx: 62, cn: ['حق بیمه با مالیات و عوارض'] },

    issuer: { cx: 11, cn: ['صادر کننده'] },
    issue_date: { cx: 137, cn: ['تاریخ صدور'] },
    reagent: { cx: 12, cn: ['معرف'] },
    expiration_date: { cx: 14, cn: ['تاریخ انقضاء تا ساعت 24 روز'] },
    start_date: { cx: 13, cn: ['تاریخ شروع از ساعت 24 روز'] },
    past_insurer: { cx: 40, cn: ['شرکت بیمه سال قبل'] },
    past_expiration_date: {
        cx: 45,
        cn: ['تاریخ انقضاء بیمه نامه سال قبل'],
    },
    added_tax: { cx: 63, cn: ['مالیات ارزش افزوده'] },
    added_toll: { cx: 64, cn: ['عوارض ارزش افزوده'] },

    airrm_cover_life: { cx: 47, cn: ['پوشش بدنی (میلیون ریال)'] },
    airrm_cover_financial: { cx: 48, cn: ['پوشش مالی (میلیون ریال)'] },
    airrm_cover_passenger: {
        cx: 49,
        cn: ['پوشش حوادث راننده (میلیون ریال)'],
    },
    issue_time: { cx: 152, cn: ['زمان ثبت'] },
    // unique_code: { cx: 77, cn: ['کد یکتای بیمه‌ نامه'] },

    third_party_insurance_amount: {
        cx: 52,
        cn: ['حق بیمه ثالث اجباری نهایی'],
    },
    passenger_insurance_amount: {
        cx: 53,
        cn: ['حق بیمه سرنشین نهایی', 'حق بیمه حوادث راننده نهایی'],
    },
    life_surplus_insurance_amount: {
        cx: 54,
        cn: ['حق بیمه مازاد بدنی نهایی'],
    },
    financial_surplus_insurance_amount: {
        cx: 55,
        cn: ['حق بیمه مازاد مالی نهایی'],
    },
    fund_fine: { cx: 56, cn: ['صندوق'] },
}

export const FORMATS: (keyof Helmet)[] = ['total_insurance_amount']

interface addInsProps {
    add: INSURANCE_STATE['add']

    onClose(): void

    onAdd(c: Helmet[]): void
    onDel(c: Helmet): void
    onEdit(c: Helmet): void
    onPrint(c: Helmet): void
    onExtention(c: Helmet): void
    onExtentionPrint(c: HelmetExtension): void
}

type SELECT = {
    show: boolean
    selected: number[]
}
export type HELMET_STATE_TYPE = {
    loadingXls: string
    rows: Row[]
    // cols: number
    // view_cols: CellValue[][]
    helmets: Helmet[]

    stat: [number, number]

    select: SELECT
}
type STATE = HELMET_STATE_TYPE & {
    loading: boolean
    status: null | 'green' | 'red'

    sec: 'file' | 'manual'

    anim: boolean
}

export const AddInsCmp: Component<addInsProps> = P => {
    const [state, setState] = createStore<STATE>({
        loading: false,
        status: null,

        sec: 'file',

        anim: false,

        loadingXls: '',
        rows: [],
        // cols: 0,
        helmets: [],
        // get view_cols() {
        //     let out: CellValue[][] = []
        //     for (let cdx = 0; cdx < this.cols; cdx++) {
        //         let col: CellValue[] = []
        //         for (let r of this.rows) {
        //             if (r[cdx] == undefined) break
        //             col.push(r[cdx]!)
        //         }
        //         out.push(col)
        //     }
        //     return out
        // },

        select: {
            show: false,
            selected: [],
        },

        stat: [-1, -1],
    })
    createEffect(
        on(
            () => P.add.show,
            s => {
                if (!s) return closed()

                if (P.add.type == 'edit') {
                    setState({
                        loading: false,
                        loadingXls: '',
                        status: null,

                        sec: 'manual',

                        helmets: [deepcopy(P.add.ins!)],
                    })
                    return
                }

                // similar to init
                closed()
            }
        )
    )

    const closed = () => {
        setState({
            loading: false,
            status: null,

            sec: 'file',

            anim: false,

            loadingXls: '',
            rows: [],
            // cols: 0,
            helmets: [],

            select: {
                show: false,
                selected: [],
            },
        })
    }

    type COMPARE_T = Omit<Helmet, 'id'>
    const keys: (keyof COMPARE_T)[] = [
        'cargo',
        'vin',
        'insurance_number',
        'expiration_date',
        'issuer_code',
        'airrm_cover_life',
        'plate_city',
        'added_toll',
        'chassis',
        'engine',
        'plate_serial',
        'issue_year',
        'manufacture_year',
        'passenger_count',
        'print_count',
        'provider',
        'third_party_insurance_amount',
        'v_group',
        'v_usage',
        'insurer_code',
        'added_tax',
        'issuer',
        'airrm_cover_financial',
        'company',
        'created_at',
        'fund_fine',
        'airrm_cover_passenger',
        'issue_time',
        'economic_number',
        'v_color',
        'v_system',
        'issue_date',
        'start_date',
        'reagent',
        'passenger_insurance_amount',
        'unique_code',
        'life_surplus_insurance_amount',
        'v_name',
        'total_insurance_amount',
        'financial_surplus_insurance_amount',
        'insurer_phone',
        'insurance_code',
        'past_insurer',
        'past_expiration_date',
        'insurer',
        'plate_number',
    ]
    const changed = createMemo(() => {
        if (P.add.type == 'add') {
            let change_xls = state.rows.length !== 0
            let change_manu = state.helmets.length !== 0

            return change_xls || change_manu
        } else {
            const h = state.helmets[0] as Partial<COMPARE_T> | undefined
            const p = P.add.ins as Partial<COMPARE_T> | undefined

            if (!h && !p) return false

            if (!h || !p) return true

            if (h.company !== p.company) return true

            return keys.some(k => {
                const a = h[k]
                const b = p[k]

                if (a == null && b == null) return false

                return String(a ?? '') !== String(b ?? '')
            })
        }
    })

    const patchHelmet = async () => {
        if (state.loading || state.loadingXls || state.status) return

        if (!changed()) {
            addAlert({
                type: 'error',
                timeout: 3,
                subject: 'مطلبی را عوض نکردید!',
            })
            return
        }

        let id = P.add.ins?.id

        if (!id) return

        let h = deepcopy(state.helmets[0]!)

        setState({ loading: true })

        const payload: Helmet = { ...h }

        let res = await api_admin_helmets_patch({ id }, payload as any)
        setState({ loading: false })

        if (!res.ok()) return setState('status', 'red')

        setState('status', 'green')
        pop_conffeties()
        P.onEdit(res.body)
    }
    const addHelmets = async () => {
        if (state.loading || state.loadingXls || state.status) return

        if (!changed()) {
            addAlert({
                type: 'error',
                timeout: 3,
                subject: 'مطلبی را عوض نکردید!',
            })
            return
        }

        if (state.helmets.length == 0) {
            addAlert({
                type: 'error',
                timeout: 3,
                subject: 'خطا!',
                content: 'در فایل آپلودی، اطلاعات بیمه‌ای یافت نشد!',
            })
            return
        }

        setState({ loading: true })

        setState(
            produce(s => {
                s.stat = [0, state.helmets.length]
            })
        )

        const N = 50
        let bmax = state.helmets.length / N + 2
        for (let batch = 0; batch <= bmax; batch++) {
            let hb = state.helmets.slice(batch * N, (batch + 1) * N)
            if (hb.length == 0) break
            let up = hb.map(async (h, id) => {
                // let payload: Helmet = { ...h }

                let res = await api_admin_helmets_post(h)
                if (!res.ok()) {
                    addAlert({
                        type: 'error',
                        subject: `خطا در ردیف ${id}`,
                        content: res.body.debug || '',
                        timeout: 3,
                    })
                    throw new Error('')
                }

                setState(
                    produce(s => {
                        s.helmets[id]!['id'] = res.body.id
                        s.stat[0] = s.stat[0] + 1
                    })
                )
            })

            await Promise.all(up)
        }

        location.reload()

        setState('loading', false)
    }

    const delIns = async () => {
        if (state.loading || state.loadingXls || !!state.status) return

        let id = P.add.ins?.id

        if (!id) return

        setState({ loading: true })

        let res = await api_admin_helmets_del({ id })

        setState({ loading: false })

        if (!res.ok()) return setState('status', 'red')
        setState('status', 'green')
        P.onDel(P.add.ins!)
        return
    }

    const pop_conffeties = () => {
        // @ts-ignore
        if (typeof window.confetti !== 'function') return

        const count = 200,
            defaults = {
                origin: { y: 0.7 },
            }

        function fire(particleRatio: number, opts: any) {
            // @ts-ignore
            window.confetti(
                Object.assign({}, defaults, opts, {
                    particleCount: Math.floor(count * particleRatio),
                })
            )
        }

        fire(0.25, {
            spread: 26,
            startVelocity: 55,
        })

        fire(0.2, {
            spread: 60,
        })

        fire(0.35, {
            spread: 100,
            decay: 0.91,
            scalar: 0.8,
        })

        fire(0.1, {
            spread: 120,
            startVelocity: 25,
            decay: 0.92,
            scalar: 1.2,
        })

        fire(0.1, {
            spread: 120,
            startVelocity: 45,
        })
    }

    const OnClose = () => {
        if (state.status == 'red')
            return setState({ loading: false, status: null })

        if (state.loading) return

        if (changed() && !state.status) {
            setPopup({
                show: true,
                title: 'ذخیره نکردید!',
                content: 'بعد از خروج، تغییرات شما اعمال نمیشوند!',
                Icon: WarningIcon,
                type: 'warning',
                onSubmit: P.onClose,
            })
            return
        }

        P.onClose()
    }

    function save_economic_number() {
        let helmet = state.helmets[0] || P.add.ins
        if (!helmet || !helmet.economic_number) return

        set_def_economic_number(helmet.economic_number)
        localStorage.setItem(LOCAL_ECONOMIC_NUMBER, helmet.economic_number)
    }

    function savePopularPhone() {
        let helmet = state.helmets[0] || P.add.ins
        if (!helmet || !helmet.insurer_phone) return

        if (helmet.insurer_phone) {
            setDefaultPhone(helmet.insurer_phone)
            localStorage.setItem(LOCAL_INSURER_PHONE, helmet.insurer_phone)
        }

        // // guard (in SSR environments)
        // if (
        //     typeof window === 'undefined' ||
        //     typeof localStorage === 'undefined'
        // )
        //     return
        //
        // const list: (Partial<Helmet> | undefined)[] = unwrap([...state.helmets])
        // if (P.add?.ins) list.push(P.add.ins)
        //
        // const map = new Map<string, { count: number; lastIdx: number }>()
        //
        // list.forEach((h, idx) => {
        //     if (!h) return
        //     const raw = h.insurer_phone ?? ''
        //     const phone = String(raw ?? '').trim()
        //     if (!phone) return
        //
        //     const prev = map.get(phone)
        //     if (prev) map.set(phone, { count: prev.count + 1, lastIdx: idx })
        //     else map.set(phone, { count: 1, lastIdx: idx })
        // })
        //
        // // choose the phone with highest count; tie -> most recent (larger lastIdx)
        // let bestPhone: string | null = null
        // let bestMeta: { count: number; lastIdx: number } | null = null
        //
        // for (const [phone, meta] of map.entries()) {
        //     if (
        //         !bestMeta ||
        //         meta.count > bestMeta.count ||
        //         (meta.count === bestMeta.count &&
        //             meta.lastIdx > bestMeta.lastIdx)
        //     ) {
        //         bestPhone = phone
        //         bestMeta = meta
        //     }
        // }

        // if (bestPhone) {
        //     setDefaultPhone(bestPhone)
        //     localStorage.setItem(LOCAL_INSURER_PHONE, bestPhone)
        // }
    }

    return (
        <div
            class='add-ins-cmp'
            classList={{ show: P.add.show }}
            onclick={OnClose}
        >
            <div
                class='add-ins-wrapper'
                onclick={e => {
                    e.stopPropagation()
                }}
            >
                <div
                    class='scaler'
                    onanimationend={() => setState({ anim: true })}
                ></div>

                <button class='close icon' type='button' onclick={OnClose}>
                    <CloseIcon />
                </button>

                <form
                    onsubmit={e => {
                        e.preventDefault()

                        if (state.select.show) return

                        savePopularPhone()
                        save_economic_number()

                        if (P.add.type == 'add') {
                            addHelmets()
                        } else {
                            patchHelmet()
                        }
                    }}
                    class='card'
                >
                    <Show when={P.add.type == 'add'}>
                        <div
                            class='sec-picker title_smaller'
                            classList={{ active: state.sec == 'manual' }}
                        >
                            <button
                                type='button'
                                class='file'
                                onclick={() => setState('sec', 'file')}
                            >
                                فایل
                            </button>
                            <button
                                type='button'
                                class='manu'
                                onclick={() => setState('sec', 'manual')}
                            >
                                دستی
                            </button>
                        </div>
                    </Show>

                    <div class='sec-ctas title_smaller'>
                        <button
                            class='sec-cta save'
                            type='submit'
                            classList={{ active: changed() }}
                        >
                            <CheckFillIcon />
                            ذخیره
                        </button>
                        <Show when={P.add.type == 'edit'}>
                            <button
                                class='sec-cta del'
                                onclick={() => {
                                    setPopup({
                                        show: true,
                                        Icon: DeleteIcon,
                                        type: 'error',
                                        title: 'بیمه رو حذف میکنید؟',
                                        content:
                                            'بعد از حذف امکان بازگشت وجود ندارد!',
                                        onSubmit: delIns,
                                    })
                                }}
                                type='button'
                            >
                                <DeleteIcon />
                                حذف
                            </button>
                            <button
                                class='sec-cta elsagh'
                                onclick={() => P.onExtention(P.add.ins!)}
                                type='button'
                            >
                                <EditIcon />
                                درخواست الحاقیه
                            </button>
                            <Show when={!changed()}>
                                <button
                                    class='sec-cta print icon'
                                    type='button'
                                    onclick={() => P.onPrint(P.add.ins!)}
                                >
                                    <PrintIcon />
                                </button>
                            </Show>
                        </Show>
                    </div>

                    <div class='secs-container'>
                        <Show when={P.add.type == 'add'}>
                            <FileSec
                                corpPick
                                state={state}
                                setState={setState}
                                add={P.add}
                            />
                        </Show>

                        <ManuSec
                            corpPick
                            state={state}
                            setState={setState}
                            add={P.add}
                            onExtPrint={c => P.onExtentionPrint(c)}
                        />
                    </div>

                    <Show when={state.select.show}>
                        <SelectedHelmets
                            pickCorp
                            count={state.select.selected.length}
                            show={state.select.show}
                            onClose={() => setState('select', 'show', false)}
                            onSave={h => {
                                let trues: Partial<Helmet> = {}

                                for (let [k, v] of objentries(h)) {
                                    if (!v) continue
                                    if (
                                        typeof v == 'string' &&
                                        v.trim().length == 0
                                    )
                                        continue

                                    trues[k] = v as any
                                }

                                let selected_ids = new Set(
                                    state.select.selected
                                )

                                setState(
                                    produce(s => {
                                        for (let oh of s.helmets) {
                                            if (!selected_ids.has(oh.id))
                                                continue

                                            for (let [k, v] of objentries(
                                                trues
                                            )) {
                                                // @ts-ignore
                                                oh[k] = v
                                            }
                                        }
                                    })
                                )

                                // let list = unwrap(state.select.selected)
                                //
                                // list.map(id => {
                                //     let idx = state.helmets.findIndex(
                                //         hel => hel.id == id
                                //     )
                                //     if (idx == -1) return
                                //
                                //     setState('helmets', idx, prev => ({
                                //         ...prev,
                                //         ...trues,
                                //     }))
                                // })
                                setState({
                                    select: {
                                        show: false,
                                        selected: [],
                                    },
                                })
                            }}
                        />
                    </Show>
                </form>

                <ExcelLoading state={state} setState={setState} add={P.add} />

                <ExcelStatus state={state} setState={setState} add={P.add} />
            </div>
        </div>
    )
}

interface SecChildPrps {
    add: INSURANCE_STATE['add']

    state: STATE
    setState: Setter<Partial<STATE>>
}

interface FileSecProps extends SecChildPrps {
    corpPick: boolean
}
export const FileSec: Component<FileSecProps> = P => {
    let excelShowerRef: HTMLDivElement

    const Uploader: Component = () => {
        const [dragOver, setDragOver] = createSignal(false)

        onMount(() => {
            let ac = new AbortController()

            document.addEventListener('drop', onDrop, {
                signal: ac.signal,
            })
            document.addEventListener('dragover', onDragOver, {
                signal: ac.signal,
            })

            onCleanup(() => {
                ac.abort()
            })
        })

        function isAcceptedFile(file: File | null) {
            if (!file) return false

            const name = file.name || ''
            const lower = name.toLowerCase()

            // بررسی پسوند
            const hasValidExt = EXCEL_EXTENSIONS.some(ext =>
                lower.endsWith(ext)
            )

            const hasValidMime = !!file.type && EXCEL_MIMES.includes(file.type)

            return hasValidExt || hasValidMime
        }

        async function handleSelectedFile(f?: File) {
            if (!f) return

            if (!isAcceptedFile(f)) {
                addAlert({
                    type: 'error',
                    subject: 'خطا!',
                    timeout: 3,
                    content:
                        'فرمت فایل آپلودی مجاز نیست. لطفاً یک فایل اکسل (.xls, .xlsx, .xlsm) انتخاب کنید.',
                })
                return
            }

            P.setState({ rows: [], loadingXls: 'درحال خواندن فایل اکسل (1/3)' })

            let rows = await readXlsxFile(f)
            // rows = rows.map(r =>
            //     r.map(c => {
            //         if (typeof c == 'string') return c.replaceAll('ي', 'ی')
            //         return c
            //     })
            // )
            // let max = 0
            // for (let r of rows) {
            //     max = Math.max(r.length, max)
            // }

            if (rows.length < 2) {
                return P.setState({
                    rows: [],
                    cols: 0,
                    helmets: [],
                    loadingXls: '',
                })
            }

            let headers = rows[0]!.map(c => {
                if (typeof c == 'string') return c.replaceAll('ي', 'ی')
                return c
            })

            let local_hmap = { ...HEL_COL_MAP }

            P.setState({ loadingXls: 'درحال پارس کردن سررشته ها (2/3)' })
            await new Promise(r => setTimeout(r, 200))

            for (let [k, v] of objentries(local_hmap)) {
                local_hmap[k].cx = -1

                for (let cn of v.cn) {
                    let ncx = headers.findIndex((l, hix) => l == cn && hix != 0)
                    if (ncx == -1) continue
                    local_hmap[k].cx = ncx
                }

                if (local_hmap[k].cx == -1) {
                    addAlert({
                        type: 'error',
                        subject: 'خطا!',
                        timeout: 3,
                        content: `ستون ${k} پیدا نشد`,
                    })
                    return
                }
            }

            P.setState({
                loadingXls: `درحال تبدیل ${rows.length - 1} بیمه به سیستم همراه (3/3)`,
            })
            await new Promise(r => setTimeout(r, 200))

            let helmets: Helmet[] = []
            let now = performance.now()

            for (let i = 1; i < rows.length; i++) {
                let r = rows[i]
                if (!r) break
                let h: Helmet = { ...HELMET_DEF, id: now + i }

                for (let [k, v] of objentries(local_hmap)) {
                    // let cv = r[v.cx]
                    let cv: any = null

                    for (let cn of v.cn) {
                        let ncx = headers.findIndex(l => l == cn)
                        if (ncx == -1) continue
                        cv = r[ncx]
                        if (cv) break
                    }

                    if (k == 'issuer_code') {
                        if (typeof cv == 'string' && cv.startsWith('n')) {
                            cv = parseInt(cv.slice(1))
                        }
                    }
                    if (cv == null || cv == undefined) continue
                    // if (!cv) continue

                    if (typeof h[k] != typeof cv) {
                        addAlert({
                            subject: `نوع نادرست: ${v.cn} | ${typeof h[k]} != ${typeof cv}`,
                            type: 'error',
                            timeout: 5,
                        })
                        continue
                    }

                    if (typeof cv == 'number') cv = ~~cv

                    // @ts-ignore
                    h[k] = cv
                }

                if (DEFAULT_PHONE && !h.insurer_phone) {
                    h.insurer_phone = DEFAULT_PHONE
                }

                if (DEFAULT_ECONOMIC_NUMBER && !h.economic_number) {
                    h.economic_number = DEFAULT_ECONOMIC_NUMBER
                }

                h.issue_year = parseInt(h.issue_date.split('/')[0]!) || -1
                h.insurer_code = h.insurer.split(' کد ')[1] || ''
                h.insurer_code = h.insurer_code.trim()

                helmets.push(h)
            }

            P.setState({ rows: rows.slice(0, 20), helmets, loadingXls: '' })
            await new Promise(r => setTimeout(r, 200))

            if (excelShowerRef) {
                excelShowerRef.scrollTo({
                    top: 0,
                    left: excelShowerRef.scrollWidth,
                    behavior: 'instant',
                })
            }

            return
        }

        const onInputChange = (e: Event) => {
            const inp = e.currentTarget as HTMLInputElement
            const f = inp.files
            if (!f || !f[0]) return

            handleSelectedFile(f[0])
            // clear so same file can be picked again later
            inp.value = ''
        }

        const onDrop = (e: DragEvent) => {
            e.preventDefault()
            e.stopPropagation()
            setDragOver(false)

            const dt = e.dataTransfer
            if (!dt) return
            if (!dt.files || dt.files.length === 0) return

            const first = dt.files[0]
            handleSelectedFile(first)
        }

        const onDragOver = (e: DragEvent) => {
            e.preventDefault() // allow drop
            e.dataTransfer!.dropEffect = 'copy'
        }

        const onDragEnter = (e: DragEvent) => {
            e.preventDefault()
            setDragOver(true)
        }

        const onDragLeave = (e: DragEvent) => {
            e.preventDefault()
            setDragOver(false)
        }

        return (
            <label
                class='uploader-cmp'
                for={'hamrah-excel-inp'}
                classList={{
                    active: dragOver(),
                    hide: P.state.rows.length > 2,
                }}
                ondragenter={onDragEnter}
                onDragLeave={onDragLeave}
            >
                <input
                    type='file'
                    id={'hamrah-excel-inp'}
                    accept={ACCEPT_STRING}
                    onChange={onInputChange}
                />
                <img
                    src='/public/imgs/excel.png'
                    decoding='async'
                    loading='lazy'
                    alt=''
                />
                <div class='upload-hints'>
                    <p class='title_small'>فایل اکسل خود را اینجا بندازید</p>
                    <p class='divider title_small'>یا</p>
                    <p class='title_small'>کلیک کنید!</p>
                </div>
            </label>
        )
    }

    const BigPaddings = [
        'معرف',
        'وضعيت',
        'مالک',
        'واحد کاری صدور',
        'واحد کاری معرف',
        'شرح قراداد',
        'آیین نامه',
        'واحد پیشنهاد دهنده',
        'بيمه گذار',
        'شماره قرارداد',
    ]
    const ExcelShower: Component = () => {
        const delFile = () => {
            P.setState({
                loadingXls: '',
                rows: [],
                cols: 0,
                helmets: [],
            })
        }

        return (
            <div
                class='shower-container'
                classList={{ active: P.state.rows.length !== 0 }}
            >
                <button
                    type='button'
                    class='del-file title_smaller'
                    onclick={delFile}
                >
                    <DeleteIcon />
                    حذف فایل
                </button>
                <div class='excel-shower' ref={e => (excelShowerRef = e)}>
                    <table>
                        <thead>
                            <tr class='title_small'>
                                <For each={P.state.rows[0]}>
                                    {t => (
                                        <th
                                            classList={{
                                                big: BigPaddings.includes(
                                                    t?.toLocaleString() || ''
                                                ),
                                            }}
                                        >
                                            {t.toLocaleString()}
                                        </th>
                                    )}
                                </For>
                            </tr>
                        </thead>
                        <tbody>
                            <For each={P.state.rows.slice(1)}>
                                {tr => (
                                    <tr class='title_smaller'>
                                        <For each={tr}>
                                            {td => (
                                                <td>
                                                    <Show
                                                        when={td}
                                                        fallback={
                                                            <span class='empty-td'>
                                                                خالی!
                                                            </span>
                                                        }
                                                    >
                                                        {td.toLocaleString()}
                                                    </Show>
                                                </td>
                                            )}
                                        </For>
                                    </tr>
                                )}
                            </For>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
    return (
        <div
            class='file-sec add-sec'
            classList={{ active: P.state.sec == 'file' }}
        >
            <Uploader />

            <ExcelShower />
        </div>
    )
}

interface ManuSecProps extends SecChildPrps {
    corpPick: boolean

    onExtPrint(c: HelmetExtension): void
}
export const ManuSec: Component<ManuSecProps> = P => {
    let lastSelected = -1
    let shiftDown = false

    onMount(() => {
        const ac = new AbortController()

        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Shift') shiftDown = true
        }
        const handleKeyUp = (e: KeyboardEvent) => {
            if (e.key === 'Shift') shiftDown = false
        }
        const handleBlurOrHide = () => {
            shiftDown = false
        }

        document.addEventListener('keydown', handleKeyDown, {
            signal: ac.signal,
            passive: true,
        })
        document.addEventListener('keyup', handleKeyUp, {
            signal: ac.signal,
            passive: true,
        })
        document.addEventListener(
            'visibilitychange',
            () => {
                if (document.hidden) handleBlurOrHide()
            },
            { signal: ac.signal }
        )

        onCleanup(() => {
            ac.abort()
        })
    })

    const addDef = () => {
        P.setState(
            produce(s => {
                s.helmets?.unshift({
                    ...HELMET_DEF,
                    id: performance.now(),
                    insurer_phone: DEFAULT_PHONE ?? HELMET_DEF['insurer_phone'],
                    economic_number:
                        DEFAULT_ECONOMIC_NUMBER ?? HELMET_DEF.economic_number,
                })
            })
        )
    }
    const closeSelect = () => {
        const close = () => {
            P.setState({ select: { show: false, selected: [] } })
        }

        if (P.state.select.selected.length < 10) return close()

        return setPopup({
            show: true,
            title: 'ذخیره نکردید!',
            content: 'بعد از بستن تغییرات شما اعمال نمیشوند.',
            Icon: WarningIcon,
            type: 'warning',
            onSubmit: close,
        })
    }
    const selectAll = () => {
        P.setState(
            produce(s => {
                if (s.select?.selected.length == P.state.helmets.length) {
                    s.select.selected = []
                } else {
                    s.select!.selected = [...P.state.helmets.map(a => a.id)]
                }
            })
        )
    }
    const showSelect = () => {
        P.setState(produce(s => (s.select!.show = true)))
    }

    const Empty: Component = () => {
        return (
            <div role='button' onclick={addDef} class='empty-helmets title'>
                <LoadingDots />
                <p>برای ادیت دستی، بیمه اضافه کنید.</p>
            </div>
        )
    }

    interface ExtentionRowProps {
        onClick(): void
        index: number
    }
    const ExtentionRow: Component<ExtentionRowProps> = E => {
        return (
            <div class='extention-row' role='button' onclick={E.onClick}>
                <div class='icon'>
                    <WarningIcon />
                </div>
                <span class='title_smaller'>
                    الحاقیه شماره {E.index} برای این بیمه ثبت شده!
                </span>
            </div>
        )
    }

    interface HelmetProps {
        h: Helmet
        index: number
    }
    const Helmet: Component<HelmetProps> = R => {
        type HELDATA = {
            ext: HelmetExtension[]
        }
        const [helState, setHelState] = createStore<HELDATA>({
            ext: [],
        })
        onMount(() => {
            getExtentions(R.h)
        })

        const getExtentions = async (h: Helmet) => {
            if (P.add.type == 'add') return

            let res = await api_admin_helmet_extensions_list({
                helmet: h.id,
                page: 0,
            })

            if (!res.ok()) return

            setHelState('ext', res.body)
        }

        function helmet_update(body: Partial<Helmet>) {
            P.setState(
                produce(s => {
                    for (let [k, v] of Object.entries(body)) {
                        // @ts-ignore
                        s.helmets[R.index][k] = v
                    }
                })
            )
        }

        const pickedCorp = (c: Company) => {
            helmet_update({ company: c.id })
        }

        const helData = createMemo(() => P.state.helmets[R.index])

        const CorpPick: Component = () => {
            let resultsRef: HTMLElement

            type DATA = {
                loading: boolean
                error: boolean
                query: string
                name: string
                id: number

                corps: Company[]
            }
            const [data, setData] = createStore<DATA>({
                loading: false,
                error: false,

                id: -1,
                name: '',
                query: '',

                corps: [],
            })

            createEffect(
                on(
                    () => R.h.company,
                    async id => {
                        if (id === null || id === undefined) return

                        resultsRef.style.maxHeight = `150px`
                        resultsRef.style.opacity = '1'

                        setData('loading', true)

                        let res = await api_admin_companies_get({ id })
                        setData('loading', false)

                        if (!res.ok()) {
                            addAlert({
                                type: 'error',
                                timeout: 3,
                                subject: 'خطا در گرفتن شرکت',
                                content: 'شرکت بیمه نامه یافت شد!',
                            })
                            return
                        }

                        let corp = res.body
                        setData(
                            produce(s => {
                                s.id = corp.id
                                s.name = corp.name
                                s.query = ''
                            })
                        )
                    },
                    {
                        defer: P.add.type == 'add',
                    }
                )
            )

            createEffect(
                on(
                    () => data.query,
                    s => {
                        if (!resultsRef) return

                        setData({ loading: true, error: false })

                        if (s.length == 0) {
                            if (data.name) {
                                resultsRef.style.opacity = '0'
                                resultsRef.style.maxHeight = '0px'
                            } else {
                                resultsRef.style.opacity = '1'
                                resultsRef.style.maxHeight = '150px'
                            }

                            return
                        }

                        searchCorps(s)
                    },
                    {
                        defer: true,
                    }
                )
            )

            onCleanup(() => {
                setData({
                    loading: false,
                    error: false,

                    id: -1,
                    name: '',
                    query: '',

                    corps: [],
                })
            })

            const setActive = () => {
                let height = resultsRef.scrollHeight

                resultsRef.style.maxHeight = `${height}px`
                resultsRef.style.opacity = '1'
            }

            const searchCorps = debounce(async (query: string) => {
                let res = await api_admin_companies_search_list({
                    name: `%${query}%`,
                })

                setData({ loading: false })

                if (!res.ok() || res.body.length == 0)
                    return setData({ error: true })

                if (data.query !== query) return

                setData({
                    corps: res.body.slice(0, 5),
                })
                setActive()
            }, 200)

            const Loading = () => {
                return (
                    <div class='loading-result title'>
                        <LoadingDots />
                        درحال گرفتن شرکت
                    </div>
                )
            }
            const Error = () => {
                return (
                    <div class='error-result title'>
                        <CloseIcon />
                        شرکتی یافت نشد!
                    </div>
                )
            }

            const delCorp = () => {
                helmet_update({
                    company: null,
                })
                setData({
                    id: -1,
                    name: '',
                    query: '',
                })
            }

            const active = createMemo(
                () => data.name.length !== 0 || data.query.length !== 0
            )
            const value = createMemo(() => (data.name ? data.name : data.query))

            interface CorpProps extends Company {
                onClick(): void
            }
            const Corp: Component<CorpProps> = C => {
                return (
                    <div role='button' class='corp-res' onclick={C.onClick}>
                        <div class='head title_small'>{C.name}</div>
                        <div class='bottom description'>
                            <div class='data'>{C.agent_count} نماینده</div>•
                            <div class='data'>
                                <CalendarIcon />
                                {new Date(
                                    C.created_at * 1e3
                                ).toLocaleDateString('fa-IR')}
                            </div>
                        </div>
                    </div>
                )
            }

            return (
                <div
                    class='corp-inp-rows'
                    classList={{
                        active:
                            (data.loading ||
                                data.error ||
                                data.corps.length !== 0) &&
                            data.query.length !== 0,
                    }}
                >
                    <div class='hover-inp-wrapper'>
                        <HoverInp
                            holder={'شرکت (اختیاری)'}
                            inpType='text'
                            acitve={active()}
                            value={value()}
                            onInp={e =>
                                setData(
                                    produce(s => {
                                        s.query = e
                                        s.name = ''
                                    })
                                )
                            }
                            Icon={<CorpsIcon />}
                            name='corp'
                            dir='rtl'
                        />
                        <Show when={helData()?.company}>
                            <button
                                onclick={delCorp}
                                class='del-corp icon'
                                type='button'
                            >
                                <DeleteIcon />
                            </button>
                        </Show>
                    </div>

                    <div
                        class='result-wrapper'
                        classList={{ active: data.query.length !== 0 }}
                        ref={e => (resultsRef = e)}
                    >
                        <Show when={!data.loading} fallback={<Loading />}>
                            <Show when={!data.error} fallback={<Error />}>
                                <For each={data.corps}>
                                    {c => (
                                        <Corp
                                            onClick={() => {
                                                pickedCorp(c)
                                                setData({
                                                    name: c.name,
                                                    id: c.id,
                                                    query: '',
                                                })
                                            }}
                                            {...c}
                                        />
                                    )}
                                </For>
                            </Show>
                        </Show>
                    </div>
                </div>
            )
        }

        return (
            <div class='helmet-cmp'>
                <Show when={helState.ext.length !== 0}>
                    <div class='extentions'>
                        <For each={helState.ext}>
                            {(ext, i) => {
                                return (
                                    <ExtentionRow
                                        onClick={() => P.onExtPrint(ext)}
                                        index={i() + 1}
                                    />
                                )
                            }}
                        </For>
                    </div>
                </Show>

                <Show when={P.add.show && P.corpPick}>
                    <CorpPick />
                </Show>
                <For each={objentries(MANUALS_LABELS)}>
                    {([k, v]) => {
                        const key = k as keyof Helmet

                        return (
                            <HoverInp
                                holder={v}
                                value={
                                    helData()
                                        ? String(helData()![key] || '')
                                        : ''
                                }
                                onInp={e =>
                                    helmet_update({
                                        [k]:
                                            typeof HELMET_DEF[k] == 'number'
                                                ? parseInt(e)
                                                : e,
                                    })
                                }
                                acitve={!!helData()?.[k]}
                                id={`inp-${String(k)}`}
                                inpType={
                                    typeof HELMET_DEF[k] == 'number'
                                        ? 'number'
                                        : 'text'
                                }
                                Icon={null}
                                format={FORMATS.includes(k)}
                                disable={k == 'provider'}
                            />
                        )
                    }}
                </For>

                <For each={objentries(HEL_COL_MAP)}>
                    {([k, { cn }]) => (
                        <HoverInp
                            holder={cn.filter(Boolean)[0]!}
                            value={helData() ? String(helData()![k] || '') : ''}
                            onInp={e =>
                                helmet_update({
                                    [k]:
                                        typeof HELMET_DEF[k] == 'number'
                                            ? parseInt(e)
                                            : e,
                                })
                            }
                            acitve={!!helData()?.[k]}
                            id={`inp-${String(k)}`}
                            inpType={
                                typeof HELMET_DEF[k] == 'number'
                                    ? 'number'
                                    : 'text'
                            }
                            Icon={null}
                            format={FORMATS.includes(k)}
                        />
                    )}
                </For>
            </div>
        )
    }

    interface HelmetWrapped extends HelmetProps {}
    const HelmetWrapped: Component<HelmetWrapped> = W => {
        const [show, setShow] = createSignal(false)

        let bodyRef: HTMLDivElement

        const toggle = () => {
            if (!bodyRef) return

            if (!show()) {
                bodyRef.style.maxHeight = '0px'
                return
            }

            let height = bodyRef.scrollHeight + 64 // paddinng
            bodyRef.style.maxHeight = `${height}px`
        }

        const toggleSelect = () => {
            const wId = W.h.id
            const helmets = P.state.helmets
            const hId = helmets.findIndex(h => h.id === wId)
            if (hId === -1) return

            if (shiftDown && lastSelected >= 0) {
                const start = Math.min(hId, lastSelected)
                const end = Math.max(hId, lastSelected)

                P.setState(
                    produce(s => {
                        const selSet = new Set(s.select?.selected ?? [])

                        let allEnabled = true
                        for (let i = start + 1; i <= end; i++) {
                            if (!selSet.has(helmets[i]!.id)) {
                                allEnabled = false
                                break
                            }
                        }

                        if (allEnabled) {
                            for (let i = start; i <= end; i++)
                                selSet.delete(helmets[i]!.id)
                        } else {
                            for (let i = start; i <= end; i++)
                                selSet.add(helmets[i]!.id)
                        }

                        const newSelected = []
                        for (const h of helmets) {
                            if (selSet.has(h.id)) newSelected.push(h.id)
                        }
                        s.select!.selected = newSelected
                    })
                )

                lastSelected = hId
                return
            }

            lastSelected = hId

            P.setState(
                produce(s => {
                    s.select!.selected ??= []
                    const idx = s.select!.selected.findIndex(id => id === wId)
                    if (idx >= 0) s.select!.selected.splice(idx, 1)
                    else s.select!.selected.push(wId)
                })
            )
        }

        const selected = createMemo(() =>
            P.state.select.selected.includes(W.h.id)
        )

        const delHelmet = () => {
            P.setState(
                produce(s => {
                    s.helmets?.splice(W.index, 1)
                    const idx = s.select!.selected.findIndex(
                        id => id === W.h.id
                    )
                    if (idx >= 0) s.select!.selected.splice(idx, 1)
                })
            )
        }

        const isEmpty = createMemo(() => {
            return (
                !W.h.engine ||
                !W.h.vin ||
                !W.h.chassis ||
                !W.h.insurer ||
                !W.h.plate_number ||
                !W.h.plate_serial ||
                !W.h.manufacture_year
            )
        })

        const noCorp = createMemo(() => {
            return !W.h.company
        })

        return (
            <div class='helmet-wrapped-container'>
                <button
                    type='button'
                    class='wrapped-select'
                    onclick={toggleSelect}
                    classList={{
                        active: P.state.select.selected.includes(W.h.id),
                    }}
                >
                    <div class='icon fill'>
                        <CheckboxFill />
                    </div>
                    <div class='icon unfill'>
                        <CheckboxUnFill />
                    </div>
                </button>
                <div
                    class='helmet-wrapped'
                    classList={{
                        active: show(),
                        green: !isEmpty() && !noCorp(),
                        selected: selected(),
                    }}
                >
                    <div
                        class='wrapped-head title_small'
                        role='button'
                        onclick={() => {
                            setShow(v => !v)
                            toggle()
                        }}
                    >
                        <div class='holder-wrapper'>
                            <div
                                class='cta icon'
                                onclick={e => {
                                    e.stopPropagation()
                                    e.preventDefault()

                                    delHelmet()
                                }}
                            >
                                <DeleteIcon />
                            </div>
                            <div class='holder'>
                                بیمه شماره {W.index + 1} {isEmpty() && '(خالی)'}{' '}
                                {noCorp() && P.corpPick && '(بدون شرکت)'}
                            </div>
                        </div>
                        <div class='arr icon'>
                            <ArrowDownIcon />
                        </div>
                    </div>
                    <div class='wrapped-body' ref={e => (bodyRef = e)}>
                        <Helmet h={W.h} index={W.index} />
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div
            class='manu-sec add-sec'
            classList={{
                active: P.state.sec == 'manual' || P.add.type == 'edit',
                editing: P.add.type == 'edit',
            }}
        >
            <Show when={P.add.type == 'add'}>
                <div class='add-cta-wrapper title_smaller'>
                    <div
                        class='save-info'
                        classList={{
                            active: P.state.select.selected.length !== 0,
                        }}
                    >
                        <div
                            class='close-save icon'
                            role='button'
                            onclick={closeSelect}
                        >
                            <CloseIcon />
                        </div>
                        <button
                            type='button'
                            class='setting-icon icon'
                            onclick={showSelect}
                        >
                            <SettingFillIcon />
                        </button>
                        <div class='title'>
                            {P.state.select.selected.length}
                        </div>
                        <div class='icon' role='button' onclick={selectAll}>
                            <SelectAllIcon />
                        </div>
                    </div>
                    <AddBtn title='اضافه دستی' onClick={addDef} />
                </div>
            </Show>
            <div class='helmets-wrapper'>
                <Show when={P.state.helmets.length !== 0} fallback={<Empty />}>
                    <Show
                        when={P.add.type == 'add'}
                        fallback={
                            <Helmet
                                index={0}
                                h={deepcopy(P.state.helmets[0]!)}
                            />
                        }
                    >
                        <For each={P.state.helmets.slice(0, 30)}>
                            {(h, idx) => (
                                <HelmetWrapped index={idx()} h={deepcopy(h)} />
                            )}
                        </For>
                    </Show>
                </Show>
            </div>
        </div>
    )
}

export const ExcelLoading: Component<SecChildPrps> = P => {
    const progressWidth = createMemo(() => {
        if (P.state.stat[1] == 0 || P.state.stat[0] == 0) return 0

        return Math.floor((P.state.stat[0] / P.state.stat[1]) * 100)
    })
    return (
        <div
            class='excel-loading title_hero'
            classList={{ active: !!P.state.loadingXls || P.state.loading }}
        >
            <Show when={P.state.loading}>
                <img
                    src='/public/imgs/logo.png'
                    decoding='async'
                    loading='lazy'
                    alt=''
                />
                <p>درحال فرستادن اطلاعات به سرور...</p>

                <Show when={P.state.stat[1] > 0}>
                    <div class='progress-wrapper'>
                        <div
                            class='inner title_small'
                            style={{ width: `${progressWidth()}%` }}
                        >
                            <span>{progressWidth()}%</span>
                        </div>
                        <div class='start title_smaller'>
                            {Math.floor(P.state.stat[0])}
                        </div>
                        <div class='finish title_smaller'>
                            {Math.floor(P.state.stat[1])}
                        </div>
                    </div>
                </Show>
            </Show>
            <Show when={P.state.loadingXls}>
                <img
                    src='/public/imgs/excel.png'
                    decoding='async'
                    loading='lazy'
                    alt=''
                />

                <p>{P.state.loadingXls}</p>
            </Show>
        </div>
    )
}
export const ExcelStatus: Component<SecChildPrps> = P => {
    return (
        <div
            class='excel-status title_hero'
            classList={{
                show: !!P.state.status,
                green: P.state.status == 'green',
                red: P.state.status == 'red',
            }}
        >
            <Show when={P.state.status == 'red'} fallback={<CheckFillIcon />}>
                <CloseIcon />
            </Show>

            <Show
                when={P.state.status == 'red'}
                fallback={'بیمه ها با موفقیت ارسال شدند'}
            >
                خطا در فرستادن بیمه ها، لطفا دوباره تلاش کنید
            </Show>
        </div>
    )
}
